import Api from "./api";

export default {
  async getOrders(config) {
    const response = await Api(config).get(config.api.orderBase);
    return response.data;
  },
  async getOrder(config, orderId) {
    if (orderId) {
      const response = await Api(config).get(`${config.api.orderBase}${orderId}/`);
      return response.data;
    }
    const response = await Api(config).get(config.api.fetchOrder);
    return response.data;
  },
  async getCart(config) {
    const response = await Api(config).get(config.api.fetchCart);
    return response.data;
  },
  async setOrderState(config, order, state) {
    const response = await Api(config).patch(`${config.api.orderBase}${order.id}/${state}/`);
    return response.data;
  },
  async setRegistrationLaboratories(config, registration, sessions) {
    const response = await Api(config).patch(`${config.api.registrationBase}${registration.id}/`, sessions);
    return response.data;
  },
  async deleteRegistration(config, registrationId) {
    const response = await Api(config).delete(`${config.api.registrationBase}${registrationId}/`);
    return response.data;
  },
  async expireOrder(config, orderId) {
    const response = await Api(config).patch(`${config.api.orderBase}${orderId}/expired/`);
    return response.data;
  },
  async addItemToOrder(config, order, item) {
    const orderItem = {
      order: order.id,
      ...item,
    };
    const response = await Api(config).post(`${config.api.registrationBase}`, orderItem);
    return response.data;
  },
  async addItemsToOrder(config, order, items) {
    const orderItems = items.map(item => {
      return {
        order: order.id,
        ...item,
      };
    });

    const response = await Api(config).post(
      `${config.api.orderBase}${order.id}${config.api.orderBundleLegs}`,
      orderItems
    );
    return response.data;
  },
  async createOrder(config, user, item, state) {
    const orderItem = {
      user: user.id,
      registrations: [item],
      state,
    };
    const response = await Api(config).post(`${config.api.orderBase}`, orderItem);
    return response.data;
  },
};
